import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { ApiErrorResponse } from 'services/types'

import { rejectResult } from '..'
import { GetFileContentResponse } from '../types'

type RejectResultParams = {
  reason: string
}

/** mutation-cache: synced by the caller (useResults onSuccess): result details and activity queries */
export const useRejectResult = (
  resultId: string,
  options?: UseMutationOptions<GetFileContentResponse, ApiErrorResponse, RejectResultParams>
) => {
  return useMutation<GetFileContentResponse, ApiErrorResponse, RejectResultParams>({
    mutationFn: ({ reason }) => rejectResult(resultId, reason),
    ...options
  })
}
